// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"6f934763","541":"f8a30397","545":"9cc06c92","787":"134e1d12"}[chunkId] + ".chunk.js";
};